import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { Collection, CollectionsProgress } from '@/types'
import { useLocalStorage } from '@vueuse/core'
import { showNotify } from 'vant';
import { collections } from '@/lib/config';
import { useAppStore } from './appStore';

export const useCollectionsStore = defineStore('collections', () => {
  const activeCollection = ref<Collection | null>(null)
  const activeCollectionName = useLocalStorage<string>('gdAppActiveCollectionName', '')
  const collectionsProgress = useLocalStorage<CollectionsProgress>('gdAppCollectionsProgress', {})
  const initialLoad = ref(true)

  const appStore = useAppStore();

  const activeProgress = computed(() => {
    return collectionsProgress.value[activeCollectionName.value] || 1
  })

  const loadCollection = async (name: string) => {
    try {
      const response = await import(`./data/${name}.json`);
      activeCollection.value = response.default
      activeCollectionName.value = name
      if (!collectionsProgress.value[activeCollectionName.value]) {
        collectionsProgress.value = { ...collectionsProgress.value, [name]: 1 }
      }
      const title = collections.find((c) => c.id === activeCollectionName.value)?.title
      if (title) {
        appStore.setPageTitle(title)
      }
      if (!initialLoad.value) {
        showNotify({ type: 'success', message: 'Colectia a fost activata cu succes.' });
      }
    } catch {
      showNotify({ type: 'danger', message: 'Am intampinat probleme. Colectia nu a fost incarcata.' });
    }
    initialLoad.value = false;
  }

  const setProgress = (progress: number) => {
    collectionsProgress.value[activeCollectionName.value] = progress
  }

  return { activeCollection, activeCollectionName, activeProgress, loadCollection, setProgress }
})
